import type {CampaignProduct} from '../../types';

import {EditOutlined, PercentageOutlined} from '@ant-design/icons';
import {Checkbox} from '@ds/components';
import {cn} from '@ds/helpers';
import {numberFormat} from 'utils/Helper';

import PromotionStockBadge from '../../../components/common/PromotionStockBadge/PromotionStockBadge';

type CampaignProductItemProps = {
  item: CampaignProduct;
  handleProductSelection: (item: CampaignProduct) => void;
  handleDiscountModal: (item: CampaignProduct) => void;
};

const CampaignProductItem: React.FC<CampaignProductItemProps> = ({
  item,
  handleProductSelection,
  handleDiscountModal
}) => {
  const selectedOption = item.suggested_option?.find((option) => option.data.selected);

  return (
    <div className="flex items-center gap-2.5">
      <div className="flex size-12 shrink-0 items-center justify-center">
        <Checkbox
          checked={item.selected}
          onChange={(event) => {
            handleProductSelection({...item, selected: event.target.checked});
          }}
        />
      </div>
      <div className="flex flex-1 items-center justify-between border-b border-gray-03 py-3">
        <div className="flex max-w-75 flex-col gap-2 text-body-sm-emphasis">
          <span className="text-body-sm-emphasis text-neutral-fg">{item.title}</span>
          {item.discount_share_type === 'brand' ? (
            <div className="flex items-center gap-2.5">
              {selectedOption ? (
                <span className="rounded bg-gray-02 px-1.5">
                  %{selectedOption.data.percentage} تخفیف فروشگاه
                </span>
              ) : null}
              <span className="inline-flex items-center gap-1 rounded bg-gray-02 px-1.5">
                <PercentageOutlined aria-hidden />
                تخفیف برند
              </span>
            </div>
          ) : null}
          <div className="flex items-center gap-1.5">
            {item.discount_share_type !== 'brand' && selectedOption ? (
              <span className="rounded bg-gray-02 px-1.5">{selectedOption.data.percentage}%</span>
            ) : null}
            <span className="text-gray-07 line-through">{numberFormat(item.price)}</span>
            {selectedOption ? (
              <span>{numberFormat(item.price - selectedOption.data.price)} تومان</span>
            ) : null}
          </div>
        </div>
        <div
          className="m-1 flex h-12 w-17 flex-col items-center justify-center gap-2.5"
          onClick={() => {
            if (item.selected) {
              handleDiscountModal(item);
            }
          }}
        >
          <EditOutlined
            className={cn('text-2xl', !item.selected && 'text-gray-04')}
            aria-hidden
          />
          <PromotionStockBadge stock={item.stock} state={item.stock_label} />
        </div>
      </div>
    </div>
  );
};

export default CampaignProductItem;
